import { Text } from '@chakra-ui/react'
import { Order, RebateCause } from '@leid/api-orders'
import { TFunction } from 'i18next'

import { removeDecimals } from './removeDecimals'

export const getReductionDescriptionText = (order: Order | undefined, t: TFunction): string => {
  if (!order) {
    return ''
  }

  let description = ''

  const rebatesAmount = order.discountAmount + (order.credits ?? 0)

  if (rebatesAmount > 0) {
    description += `${t('common:rebates')}: ${removeDecimals(rebatesAmount)} ${t('common:nok')}`
  }

  if (order.refundCredits && order.refundCredits > 0) {
    if (description) {
      description += ', '
    }
    description += `${t('common:credits')}: ${removeDecimals(order.refundCredits)} ${t('common:nok')}`
  }

  if (!description) {
    return ''
  }
  return `(${description})`
}

export const getOrderItemDescriptionText = (
  rebateAmount: number | undefined,
  rebateCause: RebateCause | undefined,
  rawPrice: number | undefined,
  personalDiscount: number | undefined,
  t: TFunction,
): string => {
  if (rebateAmount === undefined && personalDiscount === undefined) {
    return ''
  }

  let text = ''

  if (rebateAmount !== undefined) {
    const rebatePercentage = rebateCause?.percentage ?? 0
    const rawFullprice = removeDecimals((rawPrice ?? 0) + (rebateAmount ?? 0))

    const discountAmountText = `${t('common:discount')} ${rebateAmount} ${t('nok')}`
    const discountDescription = `${rebatePercentage}% ${t('common:rebateLower')} ${t(
      'ofLowerCase',
    )} ${rawFullprice} ${t('nok')} ${t('exclDeductiblesAndInsurance')}`

    text += `${discountAmountText} (${discountDescription})`
  }

  if (personalDiscount !== undefined) {
    const discountAmountText = `${t('common:personalDiscount')} ${personalDiscount} ${t('nok')}`

    text += `${text ? ', ' : ''}${discountAmountText}`
  }

  return text
}

export const orderHasDiscounts = (order: Order): boolean => {
  if (order.discountAmount > 0) {
    return true
  }

  if (order.credits && order.credits > 0) {
    return true
  }

  if (order.refundCredits && order.refundCredits > 0) {
    return true
  }

  return false
}

export const getOrderTotalPrice = (order: Order): number => {
  const totalPrice = order.totalPrice + (order.deposit ?? 0) - (order.depositUsed ?? 0)
  return totalPrice
}

export const getOrderItemPriceText = (
  price: number,
  rebateAmount: number | undefined,
  personalDiscount: number | undefined,
  t: TFunction,
  isRerent = false,
): JSX.Element => {
  return (
    <>
      <Text fontSize="md" fontWeight="bold">
        {isRerent ? (
          t('common:bestPrice')
        ) : (
          <>
            {rebateAmount !== undefined && t('common:rebatedPrice')}
            {removeDecimals(price)} {t('nok')}
          </>
        )}
      </Text>
      {(rebateAmount !== undefined || personalDiscount !== undefined) && (
        <>
          <Text fontSize="xs" textDecoration="line-through">
            {'('}
            {t('common:originalPrice')} {removeDecimals(price + (rebateAmount ?? 0) + (personalDiscount ?? 0))}{' '}
            {t('nok')}
            {')'}
          </Text>
        </>
      )}
    </>
  )
}
